import { createDealer, createRng } from '../core';
/** Marker prefix recognized by `dealForSpec`: a seed carrying this prefix embeds an exact,
 *  pre-known deal (JSON-encoded) instead of one derived by shuffling. Used by the Pluribus
 *  fixture replay, which must reproduce a REAL historical hand's exact cards rather than any
 *  seed-derived deal. Keeps dealForSpec the single deal authority - every call site still just
 *  calls dealForSpec(spec, n). */
const FIXED_DEAL_PREFIX = 'fixed-deal:';
export const encodeFixedDeal = (holeCards, board) => FIXED_DEAL_PREFIX + JSON.stringify({ holeCards, board });
export const dealForSpec = (spec, n) => {
    if (spec.seed.startsWith(FIXED_DEAL_PREFIX)) {
        return JSON.parse(spec.seed.slice(FIXED_DEAL_PREFIX.length));
    }
    const rng = createRng(spec.seed);
    const dealer = createDealer(rng);
    const holeCards = [];
    for (let seat = 0; seat < n; seat++)
        holeCards.push(dealer.deal(2));
    const board = dealer.deal(5);
    return { holeCards, board };
};
export const BOARD_LENGTH_BY_STREET = { preflop: 0, flop: 3, turn: 4, river: 5 };
//# sourceMappingURL=deal.js.map